import '@/assets/styles/index.css'
import 'floating-vue/dist/style.css'
import 'v-calendar/style.css'

import { createApp } from 'vue'
import { pinia } from '@/core/pinia'
import { i18n } from '@/core/i18n'
import router from '@/router'
import Sentry from '@/core/sentry'
import { matomoInit } from '@/core/matomo'
import FloatingVue from 'floating-vue'
import { floatingVueConfig } from '@/core/floatingVue'
import App from '@/App.vue'
import { clickOutsideColorChooserDirective } from '@/directives/clickOutsideColorChooser'
import { clickOutsideFilterDirective } from '@/directives/clickOutsideFilter'
import { trackMatomoClickDirective } from '@/directives/trackMatomoClick'

const app = createApp(App)

app.use(i18n)
app.use(pinia)
app.use(router)
app.use(FloatingVue, floatingVueConfig)

Sentry.init({ app, router })

matomoInit()

app.directive('click-outside-color-chooser', clickOutsideColorChooserDirective)
app.directive('click-outside-filter', clickOutsideFilterDirective)
app.directive('track-matomo-click', trackMatomoClickDirective)

app.mount('#app')

export { app, router }
